export default __webpack_public_path__ + "static/media/github-logo.469cc31b.svg";